<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-4">
            <!-- Loading State -->
            <div v-if="loadingData" class="text-center py-8">
              <v-progress-circular
                indeterminate
                color="blue-darken-3"
                size="64"
              ></v-progress-circular>
              <p class="mt-4 text-h6 text-grey">Loading approval details...</p>
            </div>

            <!-- Content (shown when not loading) -->
            <div v-else>
              <!-- Header Section -->
              <div>
                <h2 class="text-h5 font-weight-bold mb-2">
                  {{ $route.query.page_title  }} Approval Details
                </h2>
                
                <div class="text-body-2">
                  <v-row class="px-3 pt-5 pb-7 custom-row">
                    <v-col cols="12" md="6" class="custom-col">
                      <strong>Code:</strong> {{ documentDetails?.code || 'N/A' }}
                    </v-col>

                    <v-col v-if="commonData?.sale_order_date" cols="12" md="6" class="custom-col">
                      <strong>Sale order date:</strong> {{ formatDateDash(documentDetails?.sale_order_date) }}
                    </v-col>

                    <v-col v-else-if="documentDetails?.date" cols="12" md="6" class="custom-col">
                      <strong>Date:</strong> {{ formatDateDash(documentDetails?.date) }}
                    </v-col>

                    <v-col v-if="commonData?.date" cols="12" md="6" class="custom-col">
                      <strong>Date:</strong> {{ formatDateDash(commonData?.date) }}
                    </v-col>

                    <v-col v-if="commonData?.customer_company_name" cols="12" md="6" class="custom-col">
                      <strong>Customer Company Name:</strong> {{ commonData?.customer_company_name }}
                    </v-col>

                    <v-col v-if="commonData?.challan_date" cols="12" md="6" class="custom-col">
                      <strong>Challan Date:</strong> {{ commonData?.challan_date }}
                    </v-col>

                    <v-col v-if="commonData?.purpose" cols="12" md="6" class="custom-col">
                      <strong>Requisition Type:</strong> {{ commonData?.requisition_type?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c.toUpperCase()) || "-" }}
                    </v-col>

                    <v-col v-if="commonData?.requisition_type" cols="12" md="6" class="custom-col">
                      <strong>Purpose:</strong> {{ commonData?.purpose }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.warehouse?.name" class="custom-col">
                      <strong>Warehouse:</strong> {{ commonData?.warehouse?.name }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.warehouse" class="custom-col">
                      <strong>Warehouse:</strong> {{ commonData?.warehouse }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.department?.name" class="custom-col">
                      <strong>Department:</strong> {{ commonData?.department?.name }}
                    </v-col>

                    <v-col cols="12" md="6" v-else-if="commonData?.department" class="custom-col">
                      <strong>Department:</strong> {{ commonData?.department }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.party" class="custom-col">
                      <strong>Party / Name:</strong> {{ commonData?.party }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.total_item" class="custom-col">
                      <strong>Total Item:</strong> {{ commonData?.total_item }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.total" class="custom-col">
                      <strong>Total:</strong> {{ commonData?.total }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.remarks" class="custom-col">
                      <strong>Remarks:</strong> {{ commonData?.remarks }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.employee" class="custom-col">
                      <strong>Employee:</strong> {{ commonData?.employee?.name ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.sales_person" class="custom-col">
                      <strong>Sales Person:</strong> {{ commonData?.sales_person ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.actual_in" class="custom-col">
                      <strong>Actual In:</strong> {{ commonData?.actual_in ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.actual_out" class="custom-col">
                      <strong>Actual Out:</strong> {{ commonData?.actual_out ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.in_remarks" class="custom-col">
                      <strong>In Remarks:</strong> {{ commonData?.in_remarks ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.out_remarks" class="custom-col">
                      <strong>Out Remarks:</strong> {{ commonData?.out_remarks ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.address" class="custom-col">
                      <strong>Address:</strong> {{ commonData?.address ?? '-' }}
                    </v-col>

                    <v-col cols="12" md="6" v-if="commonData?.created_by" class="custom-col">
                      <strong>Created By:</strong> {{ commonData?.created_by ?? '-' }}
                    </v-col>

                    <!-- Leave -->
                    <template v-if="modelClass == 'Modules\\Leave\\Models\\Leave'">
                      <v-col cols="12" md="6" class="custom-col">
                        <strong>Leave Type:</strong> {{ commonData?.balance?.leave_type_name || '-' }}
                      </v-col>

                      <v-col cols="12" md="6" class="custom-col">
                        <strong>Balance:</strong>
                        {{ commonData?.balance?.entitled_days || 0 }} /
                        {{ commonData?.balance?.remaining_days || 0 }}
                      </v-col>
                    </template>

                  </v-row>
                </div>

                <sls-sale-order-details-table 
                  v-if="this.referenceableTypeModel === 'SlsSaleOrderMaster'"
                />
                <sls-sample-order-details-table
                  v-else-if="referenceableTypeModel === 'SlsSampleOrderMaster'"
                />
                <sls-sale-invoice-details-table
                  v-else-if="referenceableTypeModel === 'SlsSaleInvoiceMaster'"
                />
                <inv-sale-invoice-delivery-details-table
                  v-else-if="referenceableTypeModel === 'InvSaleInvoiceDeliveryMaster'"
                />
                <inv-sample-delivery-details-table
                  v-else-if="referenceableTypeModel === 'InvSampleDeliveryMaster'"
                  :reference-type="'InvSampleDeliveryMaster'"
                />
                <inv-direct-receive-details-table
                  v-else-if="referenceableTypeModel === 'InvDrReceiveMaster'"
                />
                <inv-lc-receive-details-table
                  v-else-if="referenceableTypeModel === 'InvLcReceiveMaster'"
                />
                <inv-po-receive-details-table
                  v-else-if="referenceableTypeModel === 'InvPoReceiveMaster'"
                />
                <inv-po-landed-cost-details-table
                  v-else-if="referenceableTypeModel === 'InvPoLandedCostMaster'"
                />
                <purchase-order-details-table
                  v-else-if="referenceableTypeModel === 'PurOrderMaster'"
                />
                <purchase-requisition-details-table
                  v-else-if="referenceableTypeModel === 'PurRequisitionMaster'"
                />
                <hrm-increment-details-table
                  v-else-if="referenceableTypeModel === 'HrmIncrement'"
                />
                <lc-master-details-table
                  v-else-if="referenceableTypeModel === 'LcImportLcMaster'"
                />
                <lc-amendment-details-table
                  v-else-if="referenceableTypeModel === 'LcImportLcAmendment'"
                />
                <lc-import-proforma-invoice-details-table
                  v-else-if="referenceableTypeModel === 'LcImportProformaInvoiceMaster'"
                />
                <hrm-claim-internal-bill-details-table
                  v-else-if="referenceableTypeModel === 'HrmClaimMaster'"
                  :claim-data="claimData"
                  @update-claim-details="updateClaimDetails"
                />
                
              </div>
              
              <v-divider class="my-12" :thickness="2"></v-divider>

            <!-- Show message when all steps are completed -->
            <v-alert
              v-if="approval_process.length > 0 && isProcessComplete"
              type="success"
              icon="mdi-check-all"
              variant="tonal"
              class="p-0 mt-2 pl-4"
              border="start"
              prominent
            >
              <div class="text-subtitle-2">
                ✓ All approval steps completed
              </div>
            
            </v-alert>

            <!-- Approval Workflow Timeline -->
          <div class="mb-2">
            <div class="horizontal-timeline">
              <div 
                v-for="(approval, index) in approval_process" 
                :key="index"
                class="timeline-step"
              >

                <div 
                  v-if="index > 0" 
                  class="step-connector"
                  :class="{ 
                    'connector-approved': 
                      approval_process[index - 1]?.status?.toLowerCase() === 'approved' || 
                      (isProcessComplete && (
                        approval_process[index - 1]?.status?.toLowerCase() === 'approved' || 
                        approval_process[index - 1]?.status?.toLowerCase() === 'pending'
                      ))
                  }"
                >
                  <div class="connector-arrow"></div>
                </div>

                <div class="step-content">

                  <div 
                    class="step-circle" 
                    :class="getApprovalClass(approval.status, index)"
                  >
                    <v-icon size="medium" color="white">
                      {{ getApprovalIcon(approval.status, index) }}
                    </v-icon>
                  </div>

                  <div class="step-info">

                    <!-- TITLE PART (unchanged) -->
                    <div class="step-title status-approved-text" v-if="approval.status === 'Approved'">
                      Approved By {{ approval.approval_step_name?.name || 'Approver' }}
                    </div>

                    <div class="step-title status-cancelled-text" v-else-if="approval.status === 'Cancelled'">
                      Cancelled By {{ approval.approval_step_name?.name || 'Approver' }}
                    </div>

                    <div class="step-title status-skipped-text" v-else-if="approval.status === 'Pending' && isProcessComplete">
                      Skipped - {{ approval.approval_step_name?.name || 'Approver' }}
                    </div>

                    <div class="step-title" v-else-if="approval.status === 'Pending' && !isProcessComplete && isCurrentStep(index)">
                      <span class="current-step-title">
                        Waiting for {{ approval.approval_step_name?.name || 'Approver' }}
                      </span>
                    </div>

                    <div class="step-title status-pending-text" v-else-if="approval.status === 'Pending' && !isProcessComplete">
                      Waiting for {{ approval.approval_step_name?.name || 'Approver' }}
                    </div>

                    <div class="step-title" v-else>
                      {{ approval.approval_step_name?.name || 'Approver' }}
                    </div>

                    <!-- STATUS PART -->
                    <div class="step-status">

                      <span v-if="approval.status === 'Approved'">
                        {{ formatDateDash(approval.approved_at) }}
                      </span>

                      <span v-else-if="approval.status === 'Cancelled'">
                        {{ formatDateDash(approval.approved_at) }}
                      </span>

                      <span v-else-if="approval.status === 'Pending' && isProcessComplete">
                        <div class="text-grey" style="font-style: italic;">
                          Process completed early
                        </div>
                      </span>

                      <!-- 🔥 Always Show Employee Name -->
                      <div class="employee-name">
                        {{ approval.employee?.name || 'N/A' }}
                      </div>

                      <div v-if="isCurrentStep(index)">
                        Started: {{ formatDateDash(getCurrentStepStartTime(index)) }}
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- Previous Comments Section -->
            <div class="mb-2">
              <h3 class="text-subtitle-1 font-weight-bold mb-2">Previous Comments:</h3>
              <div v-if="previousComments.length > 0">
                <div 
                  v-for="(comment, index) in previousComments" 
                  :key="index"
                  class="comment-box mb-2"
                  :class="{
                    'comment-box-rejected': comment.status === 'Cancelled',
                    'comment-box-approved': comment.status === 'Approved'
                  }"
                >
                  <div class="comment-header">
                    <span class="comment-status" :class="{
                      'status-rejected': comment.status === 'Cancelled',
                      'status-approved': comment.status === 'Approved'
                    }">
                      {{ comment.status }}:
                    </span>
                    {{ comment.approval_step_name?.name }}: {{ comment.comments || 'No comments' }}
                  </div>
                  <div class="comment-date">
                    {{ formatDateDash(comment.approved_at) }}
                  </div>
                </div>
              </div>
              <div v-else class="text-grey text-body-2 pa-3" style="background: #f5f5f5; border-radius: 4px;">
                No previous comments yet
              </div>
            </div>

            <!-- Add Your Comment Section -->
            <div class="mb-2" v-if="currentApprovalStep && canApprove">
              <h3 class="text-subtitle-1 font-weight-bold mb-2">Add Your Comment:</h3>
              <v-textarea
                v-model="userComment"
                placeholder="Write your comments here (optional)..."
                rows="1"
                variant="outlined"
                bg-color="grey-lighten-5"
                density="compact"
                maxlength="225"
                :counter="225"
                :error-messages="commentError"
                clearable
              ></v-textarea>
            </div>

          <div class="mb-5" v-if="canApprove || canReject">
            <v-devider></v-devider>
            <v-row>
              <v-col class="border" v-if="modelClass == 'Modules\\Purchase\\Models\\PurRequisitionMaster'" cols="12" md="6">
                <v-autocomplete
                  label="Requisition"
                  variant="outlined"
                  density="compact"
                  bg-color="grey-lighten-4"
                  v-model="requisition_type"
                  :items="getRequisitionTypeList()"
                  :item-title="(item) => `${item.label}`"
                  item-value="value"
                  autocomplete="off"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                  <template #label>
                    Requisition Type
                    <span class="text-red-accent-4">*</span>
                  </template>
                </v-autocomplete>
                <div class="d-flex justify-end mt-2">
                  <v-btn size="small" color="success" @click="updateItemData"> Update Requisition Type </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-devider></v-devider>
          </div>

            <!-- Action Buttons -->
            <div class="d-flex gap-2" v-if="canApprove || canReject">
              <v-btn
                v-if="canApprove && isForwardEnabled"
                color="yellow"
                @click="handleForward"
                :loading="loadingForward"
                :disabled="loadingApprove || loadingReject"
              >
                Forward
              </v-btn>
              <v-btn
                v-if="canApprove"
                color="success"
                @click="handleApprove"
                :loading="loadingApprove"
                :disabled="loadingReject || loadingForward"
              >
                Approve
              </v-btn>
              <v-btn
                v-if="canReject"
                color="error"
                @click="handleCancel"
                :loading="loadingReject"
                :disabled="loadingApprove || loadingForward"
              >
                Reject
              </v-btn>
              <!-- <v-btn
                color="grey"
                @click="goBack"
              >
                Back
              </v-btn> -->
            </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import Axios from "axios";
import { toast } from "vue3-toastify";
import { 
  getApprovalRequestDetails as getApprovalRequestDetailsApi,
  updateApprovalStatus as updateApprovalStatusApi,
  updateItemData as updateItemDataApi
} from "@/store/api";

import slsSaleOrderDetailsTable from "@/components/common/approvalDetailsTable/slsSaleOrderDetailsTable.vue";
import slsSampleOrderDetailsTable from "@/components/common/approvalDetailsTable/slsSampleOrderDetailsTable.vue";
import slsSaleInvoiceDetailsTable from "@/components/common/approvalDetailsTable/slsSaleInvoiceDetailsTable.vue";
import invDirectReceiveDetailsTable from "@/components/common/approvalDetailsTable/invDirectReceiveDetailsTable.vue";
import purchaseOrderDetailsTable from "@/components/common/approvalDetailsTable/purchaseOrderDetailsTable.vue";
import purchaseRequisitionDetailsTable from "@/components/common/approvalDetailsTable/purchaseRequisitionDetailsTable.vue";
import invPoReceiveDetailsTable from "@/components/common/approvalDetailsTable/invPoReceiveDetailsTable.vue";
import invPoLandedCostDetailsTable from "@/components/common/approvalDetailsTable/invPoLandedCostDetailsTable.vue";
import hrmIncrementDetailsTable from "@/components/common/approvalDetailsTable/hrmIncrementDetailsTable.vue";
import { formatDateDash } from "@/plugins/helpers";
import hrmClaimInternalBillDetailsTable from "@/components/common/approvalDetailsTable/hrmClaimInternalBillDetailsTable.vue";
import invLcReceiveDetailsTable from "@/components/common/approvalDetailsTable/invLcReceiveDetailsTable.vue";
import invSaleInvoiceDeliveryDetailsTable from "@/components/common/approvalDetailsTable/invSaleInvoiceDeliveryDetailsTable.vue";
import invSampleDeliveryDetailsTable from "@/components/common/approvalDetailsTable/invSampleDeliveryDetailsTable.vue";
import LcMasterDetailsTable from "@/components/common/approvalDetailsTable/lcMasterDetailsTable.vue";
import LcAmendmentDetailsTable from "@/components/common/approvalDetailsTable/lcAmendmentDetailsTable.vue";
import LcImportProformaInvoiceDetailsTable from "@/components/common/approvalDetailsTable/lcImportProformaInvoiceDetailsTable.vue";

export default {
  name: "JournalVoucherApprovalPreview",
  components: {
    LcMasterDetailsTable,
    LcAmendmentDetailsTable,
    LcImportProformaInvoiceDetailsTable,
    slsSaleOrderDetailsTable,
    slsSampleOrderDetailsTable,
    slsSaleInvoiceDetailsTable,
    invSaleInvoiceDeliveryDetailsTable,
    invSampleDeliveryDetailsTable,
    invDirectReceiveDetailsTable,
    invLcReceiveDetailsTable,
    purchaseOrderDetailsTable,
    purchaseRequisitionDetailsTable,
    invPoReceiveDetailsTable,
    invPoLandedCostDetailsTable,
    hrmIncrementDetailsTable,
    hrmClaimInternalBillDetailsTable
  },
  data() {
    return {
      commonData: {},
      modelClass: null,
      approval_process: [],
      documentDetails: null,
      userComment: "",
      commentError: "",
      // Separate loading flags so only the clicked action shows loading
      loadingApprove: false,
      loadingReject: false,
      loadingForward: false,
      loadingData: true,
      isForwardStatus: 0,
      requisition_type: null,

      referenceableTypeModel: null,
      claimData: null,
      
    };
  },

  computed: {
    previousComments() {
      return this.approval_process.filter(
        (approval) => approval.status === 'Approved' || approval.status === 'Cancelled'
      ).filter(approval => approval.comments); // Only show if there are comments
    },

    // Check if user has approve permission using approval_permission from API
    canApprove() {
      const hasPermission = this.currentApprovalStep?.approval_permission === true;
      return this.currentApprovalStep && hasPermission;
    },

    // Check if user has reject permission using approval_permission from API
    canReject() {
      const hasPermission = this.currentApprovalStep?.approval_permission === true;
      
      return this.currentApprovalStep && hasPermission;
    },

    currentApprovalStep() {
      // Check if the parent document is already approved (process ended)
      // This happens when is_forward = 1 and Approve was clicked
      const parentApprovalStatus = this.documentDetails?.approval_status;
      if (parentApprovalStatus?.toLowerCase() === 'approved') {
        return null; // No current step if already approved
      }

      // Find the first pending approval step
      const currentStep = this.approval_process.find(
        (approval) => approval.status?.toLowerCase() === 'pending'
      );

      if (!currentStep) return null;

      // The approval_permission is already provided by the API
      // No need to calculate it manually
      const isForward = this.isForwardStatus;
  
      
      return currentStep;
    },

    isFinalStep() {
      // Use the is_final_step field directly from the API response
      return this.currentApprovalStep?.is_final_step === 1;
    },

    // Check if forward is enabled for this approval name
    isForwardEnabled() {
      // Check is_forward from the nested structure: matrix_detail.matrix.approval_name.is_forward
      const isForward = this.isForwardStatus;

      const isFinalStep = this.currentApprovalStep?.is_final_step === 1;

      
      return isForward && !isFinalStep;
    },

    // Check if the approval process is complete
    isProcessComplete() {
      // Check from documentDetails first
      let parentApprovalStatus = this.documentDetails?.approval_status;
      
      // If not found, try to get it from the first approval step's referenceable
      if (!parentApprovalStatus && this.approval_process.length > 0) {
        parentApprovalStatus = this.approval_process[0]?.referenceable?.approval_status;
      }
      
      const isComplete = parentApprovalStatus?.toLowerCase() === 'approved';
      
      return isComplete;
    },

    // Check if the process was completed via forward approval (is_forward = 1)
    wasForwardApproved() {
      if (!this.isProcessComplete) return false;
      
      // Check if any approved step has is_forward = 1
      const approvedStep = this.approval_process.find(
        (approval) => approval.status?.toLowerCase() === 'approved'
      );
      
      if (approvedStep) {
        const isForward = this.isForwardStatus;
        return isForward === 1 || isForward === '1';
      }
      
      return false;
    },
  },

  watch: {
    claimData(val) {
      console.log(val)
    },
    "$route.query": {
      handler(newQuery) {
        this.loadApprovalDetails();
      },
      deep:true

    },
    // Clear error message when user starts typing
    userComment() {
      if (this.commentError && this.userComment) {
        this.commentError = '';
      }
    }
  },

  created() {
    this.loadApprovalDetails();
  },

  methods: {
    formatDateDash,
    updateClaimDetails(data) {
      this.claimData = data;
    },
    getRequisitionTypeList() {
      return [
        { value: 'with_cs', label: 'With CS' },
        { value: 'without_cs', label: 'Without CS'},
      ];
    },
    async loadApprovalDetails() {
      try {
        this.loadingData = true;
        
        if (!this.$route.params.id && !this.$route.query.referenceable_id) {

          this.goBack();
          return;
        }

        // Get parameters from route query
        const referenceableType = this.$route.query.referenceable_type;
        const referenceableId = this.$route.query.referenceable_id || this.$route.params.id;
        
        // Check if referenceable_type is provided
        if (!referenceableType) {
          toast.error("Missing reference type. Unable to load approval details.");
          this.goBack();
          return;
        }      
        const payload = {
          referenceable_type: referenceableType,
          referenceable_id: referenceableId,
        };
        
        const response = await Axios.post(getApprovalRequestDetailsApi, payload);

        if (response.data.success) {
          this.approval_process = response.data.data || [];
          this.isForwardStatus = response.data.is_forward;
          this.commonData = response.data.common_data || {};
          this.modelClass = response.data.modelClass || null;
          this.requisition_type = this.commonData?.requisition_type ?? null;
      
          // Log the current step if it exists
          const currentStep = this.approval_process.find(step => step.status?.toLowerCase() === 'pending');
       
          if (this.approval_process.length > 0) {
            this.documentDetails = this.approval_process[0].referenceable;
            // If parent is already approved, log it
            if (this.documentDetails?.approval_status?.toLowerCase() === 'approved') {
            }
          } else {
            toast.warning("No approval steps found for this document");
          }
        } else {
          toast.error(response.data.message || "Failed to load approval details");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load approval details");
        this.goBack();
      } finally {
        this.loadingData = false;
      }
    },

    async updateItemData() {
      if (!this.requisition_type) {
        toast.error("Requisition Type is required");
        return;
      }

      try {
        const payload = {
          referenceable_type: this.$route.query.referenceable_type ?? null,
          referenceable_id: this.$route.query.referenceable_id ?? null,
          requisition_type: this.requisition_type ?? null,
        };

        const response = await Axios.post(`${updateItemDataApi}`, payload);
        if (response.data.success) {
          toast.success("Requisition Type updated successfully");
          await this.loadApprovalDetails();
        } else {
          toast.error(response.data.message || "Update failed");
        }
      } catch (error) {
        const res = error.response;
        if (res?.data?.message && typeof res.data.message === 'object') {
          Object.values(res.data.message).forEach(messages => {
            if (Array.isArray(messages)) {
              messages.forEach(msg => toast.error(msg));
            } else {
              toast.error(messages);
            }
          });
        }
        else if (res?.data?.message) {
          toast.error(res.data.message);
        } 
        else {
          toast.error("Something went wrong");
        }
      }
    },

    async handleForward() {
      if (!this.canApprove) {
        toast.error("You are not authorized to forward this step");
        return;
      }

      // Validate comment length only if comment is provided (defensive - textarea has maxlength)
      if (this.userComment && this.userComment.length > 225) {
        this.commentError = 'Comment cannot exceed 225 characters';
        toast.error('Comment cannot exceed 225 characters');
        return;
      }

      // Clear any previous errors
      this.commentError = '';

      this.loadingForward = true;
      try {

        const payload = {
          comments: this.userComment || "",
          status: "Forwarded",
          ...this.claimData,
        };

        const response = await Axios.post(
          `${updateApprovalStatusApi}/${this.currentApprovalStep.id}`,
          payload,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        if (response.data.success) {
          toast.success('Forwarded successfully');
          // Clear only the comment text after successful forward
          this.userComment = '';
          this.commentError = '';
          await this.loadApprovalDetails(); // Reload to show updated status
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to forward');
        console.error('Error details:', error.response || error);
      } finally {
        this.loadingForward = false;
      }
    },

    async handleApprove() {
      if (!this.canApprove) {
        toast.error("You are not authorized to approve this step");
        return;
      }

      // Validate comment length only if comment is provided (defensive - textarea has maxlength)
      if (this.userComment && this.userComment.length > 225) {
        this.commentError = 'Comment cannot exceed 225 characters';
        toast.error('Comment cannot exceed 225 characters');
        return;
      }

      // Clear any previous errors
      this.commentError = '';

      this.loadingApprove = true;
      try {

        const payload = {
          comments: this.userComment || "",
          status: "Approved",
          ...this.claimData,
        };

        const response = await Axios.post(
          `${updateApprovalStatusApi}/${this.currentApprovalStep.id}`,
          payload,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        if (response.data.success) {
          toast.success('Approved successfully');
          // Clear only the comment text after successful approval
          this.userComment = '';
          this.commentError = '';     
          await this.loadApprovalDetails(); // Reload to show updated status
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to approve');
        console.error('Error details:', error.response || error);
      } finally {
        this.loadingApprove = false;
      }
    },

    async handleCancel() {
      if (!this.canReject) {
        toast.error("You are not authorized to cancel this step");
        return;
      }

      // Validate comment length only if comment is provided (defensive - textarea has maxlength)
      if (this.userComment && this.userComment.length > 225) {
        this.commentError = 'Comment cannot exceed 225 characters';
        toast.error('Comment cannot exceed 225 characters');
        return;
      }

      // Clear any previous errors
      this.commentError = '';

      this.loadingReject = true;
      try {
        const formData = new FormData();

        const payload = {
          comments: this.userComment || "",
          status: "Cancelled",
          ...this.claimData,
        };

        const response = await Axios.post(
          `${updateApprovalStatusApi}/${this.currentApprovalStep.id}`,
          payload,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        if (response.data.success) {
          toast.success('Cancelled successfully');
          // Clear only the comment text after successful cancel
          this.userComment = '';
          this.commentError = '';
          await this.loadApprovalDetails(); // Reload to show updated status
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to cancel');
        console.error('Error details:', error.response || error);
      } finally {
        this.loadingReject = false;
      }
    },

    getDateField() {
      if (!this.documentDetails) return 'N/A';
      
      // Try common date field names
      return this.documentDetails.voucher_date || 
             this.documentDetails.requisition_date || 
             this.documentDetails.order_date || 
             this.documentDetails.date || 
             this.documentDetails.created_at || 
             'N/A';
    },

    getAmountField() {
      if (!this.documentDetails) return 'N/A';
      
      // Try common amount field names
      const amount = this.documentDetails.total_debit ?? 
                     this.documentDetails.total_amount ?? 
                     this.documentDetails.amount ?? 
                     this.documentDetails.total_credit ??
                     this.documentDetails.grand_total ??
                     this.documentDetails.net_amount ??
                     this.documentDetails.total;
      
      return amount !== null && amount !== undefined ? this.formatCurrency(amount) : 'N/A';
    },

    goBack() {
      this.$router.push({ name: "approval-request-record" });
    },

    isCurrentStep(index) {
      // Don't show current step if process is complete
      if (this.isProcessComplete) return false;
      
      if (!this.approval_process || this.approval_process.length === 0) return false;

      const firstPendingIndex = this.approval_process.findIndex(
        (approval) => approval.status?.toLowerCase() === 'pending'
      );

      return index === firstPendingIndex;
    },

    getCurrentStepStartTime(index) {
      // If there's a previous step and it's approved, use its approval time
      if (index > 0 && this.approval_process[index - 1]) {
        const previousStep = this.approval_process[index - 1];
        if (previousStep.status?.toLowerCase() === 'approved' && previousStep.approved_at) {
          return previousStep.approved_at;
        }
      }
      // Otherwise, use the current step's created_at
      return this.approval_process[index]?.created_at;
    },

    getApprovalClass(status, index) {
      if (!status) return 'step-circle-grey';
      const statusLower = status.toLowerCase();
      if (statusLower === 'approved') return 'step-circle-success';
      if (statusLower === 'pending') {
        // If process is complete and step is pending, show as skipped
        if (this.isProcessComplete) return 'step-circle-skipped';
        return this.isCurrentStep(index) ? 'step-circle-blue' : 'step-circle-pending';
      }
      if (statusLower === 'rejected' || statusLower === 'cancelled') return 'step-circle-error';
      return 'step-circle-grey';
    },

    getApprovalIcon(status, index) {
      if (!status) return 'mdi-help';
      const statusLower = status.toLowerCase();
      if (statusLower === 'approved') return 'mdi-check';
      if (statusLower === 'forwarded') return 'mdi-share';
      if (statusLower === 'pending') {
        // If process is complete and step is pending, show as skipped
        if (this.isProcessComplete) return 'mdi-skip-next';
        return this.isCurrentStep(index) ? 'mdi-reload' : 'mdi-clock-outline';
      }
      if (statusLower === 'rejected' || statusLower === 'cancelled') return 'mdi-close';
      return 'mdi-help';
    },

    formatCurrency(value) {
      return parseFloat(value || 0).toFixed(2);
    },
  },

  mounted() {
    const referenceModel = this.$route.query.referenceable_type
    this.referenceableTypeModel = referenceModel.split("\\").pop();
    console.log(this.referenceableTypeModel);
  }
};
</script>

<style scoped>
/* Timeline Styles */

.custom-row {
  /* border: 1px solid #000000; */
}

.custom-col {
  border: 1px solid #000000;
  padding: 5px;
}

.custom-bordered {
  border: 1px solid #000000;
}

.custom-bordered th,
.custom-bordered td {
  border: 1px solid #000000 !important;
}

.text-h5{
  font-size: 19px !important;
}

.horizontal-timeline {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  padding: 0;
  border-radius: 8px;
  margin-bottom: 2px;
}

.timeline-step {
  display: flex;
  align-items: flex-start;
  position: relative;
  min-width: 180px;
  flex-shrink: 0;
}

.step-connector {
  width: 60px;
  height: 2px;
  background: #e0e0e0;
  position: absolute;
  top: 24px;
  left: -30px;
  z-index: 0;
  transition: all 0.3s ease;
}

.connector-approved {
  background: #4CAF50;
}

.connector-arrow {
  position: absolute;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid #e0e0e0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

.connector-approved .connector-arrow {
  border-left-color: #4CAF50;
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
  position: relative;
  border: 2px solid white;
}

.step-circle-success {
  background: linear-gradient(135deg, #4CAF50 0%, #2e7d32 100%);
}

.step-circle-pending {
  background: linear-gradient(135deg, #FF9800 0%, #ef6c00 100%);
}

.step-circle-blue {
  background: linear-gradient(135deg, #2196F3 0%, #1565C0 100%);
  animation: pulse-ring 2s infinite;
}

.step-circle-error {
  background: linear-gradient(135deg, #f44336 0%, #c62828 100%);
}

.step-circle-grey {
  background: linear-gradient(135deg, #9e9e9e 0%, #616161 100%);
}

.step-circle-skipped {
  background: linear-gradient(135deg, #9e9e9e 0%, #757575 100%);
  opacity: 0.6;
}

@keyframes pulse-ring {
  0% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.7), 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(33, 150, 243, 0), 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0), 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}


.step-title {
  font-size: 0.675rem;
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 2px;
}

.step-info {
  text-align: center;
  width: 220px;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
}

.status-approved-text {
  color: #4caf50 !important;
}

.status-pending-text {
  color: #ef6c00 !important;
}

.status-cancelled-text {
  color: #f44336 !important;
}

.status-skipped-text {
  color: #757575 !important;
  font-style: italic;
}

.step-status {
  font-size: 0.75rem;
  color: #666;
}

.employee-name {
  font-size: 0.65rem;
  color: #424242;
  font-weight: 600;
  margin-bottom: 2px;
}

.current-step-title {
  color: #2196F3 !important;
}

/* Comment Box Styles */
.comment-box {
  background: #f5f5f5;
  border-left: 3px solid #2196F3;
  padding: 8px 12px;
  border-radius: 4px;
  word-break: break-word;
  transition: all 0.3s ease;
}

.comment-box-rejected {
  background: #fff5f5;
  border-left-color: #f44336;
}

.comment-box-approved {
  background: #f5fff5;
  border-left-color: #4caf50;
}

.comment-header {
  font-weight: 600;
  font-size: 0.875rem;
  color: #333;
  margin-bottom: 4px;
  line-height: 1.4;
}

.comment-status {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 0.75rem;
  font-weight: bold;
}

.status-rejected {
  background-color: #ffebee;
  color: #d32f2f;
}

.status-approved {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.comment-date {
  font-size: 0.75rem;
  color: #666;
  margin-top: 4px;
}

.gap-2 {
  gap: 8px;
}


</style>
